export default __webpack_public_path__ + "static/media/CollaboIcon.d404271b.svg";